import React, { Component } from 'react';
import './PoolRecruiter.css';
import { withRouter } from "react-router-dom";
import { Link } from 'react-router-dom';
import { Grid, Row, Col,Modal } from 'react-bootstrap';
import { Form, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import axios from '../../../services/axios-service';
import * as actions from '../../../store/actions/index';
import { connect } from 'react-redux';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import Button from '../../../components/UI/Button/Button';
import ProfileEdit from '../../../container/Recruiter/ProfileEdit/ProfileEdit';
import Stepper from '../../../components/UI/Stepper/Stepper';
import CandidateCard from '../../../components/Client/CandidateCard/CandidateCard';
import removeIcon from '../../../assets/images/remove.svg';
import recruiterEditIcon from '../../../assets/images/recruiter-profile-edit.svg';
import Icon from '../../../components/UI/Icon/Icon';
import { checkValidity } from '../../../shared/utility';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import SearchBox from '../../../components/UI/SearchBox/SearchBox';
import searchIcon from '../../../assets/images/search.svg';
import clearIcon from '../../../assets/images/search-clear.png';
import RescheduleCard from '../../../components/Recruiter/RescheduleCard/RescheduleCard';
import ToastNotification from '../../../components/UI/ToastNotification/ToastNotification';

const PoolRecruiterHeader = (props) => {
	if (props.isJobAdded)
	return (
    <h1 className="pool-title">
      Candidate list for<br />
      <strong>Customer Service Advisor Role 12316</strong>
    </h1>
	)
	return (
		<React.Fragment>
	    <h1 className="pool-recruiter__title--new">
	      Candidate list for Customer Service Advisor Role 12316
	    </h1>
			<Stepper className="pool-recruiter__stepper" steps={ props.steps } activeStep={2} {...props.stepperStyle} />
		</React.Fragment>
	)
}

const CandidateRowMobile = (props) => {
  return (
    <tr>
      <td className="bullhorn-id">{props.bullhornID}</td>
      <td className="name">
      	<div>{props.candidate_fname} {props.candidate_lname}</div>
      	<div className="current-employer">{props.currentEmployer}</div>
      </td>
      <td className="actions" >
        {/* <Link to={
            {pathname:"/recruiter/pool-import/candidate/" + props.candidateId + "/" + props.jobId, 
            state: {jobTitle:props.jobTitle, jobBH: props.jobBH }}
          }> */}
          <img src={recruiterEditIcon} onClick={props.handleModal} />
        {/* </Link> */}
      </td>
      <td>
        <img src={removeIcon}  onClick={props.deleteConfirm} />
      </td>
    </tr>
  );
}

/**
 * @desc show importrd candidate details under specific job title
 * @param props
 * @return DOMElement
 */
const PermittedContactRow = (props) => {
  return (
    <tr>
      <td className="date-added hidden-xs">{props.dateAdded}</td>
      <td className="bullhorn-id">{props.bullhornID}</td>
      <td className="name"><div>{props.name}</div></td>
      <td className="email hidden-xs">{props.email}</td>
      {/* <td className="no-of-candidates hidden-xs">{props.noOfCandidate}</td> */}
      <td className="actions" >
        <div className="permitted-close-icon">
          <Icon icon="remove"  className="" onClick={()=>props.handleRemoveContactModal()} />
        </div> 
      </td>      
    </tr>   
  );
}
/**
* @desc Recruiter view to edit imported candidates profile
* @version 0.1.0
* @author Jamshith,Lakshmikanth,Amrutha,praveen
*/
class PoolRecruiter extends Component {

  constructor(props) {
    super(props)

    this.state = {
      activeCandidateId: null,
      deleteModal:false,
      deleteContactModal:false,
      sendWarningModal :false,
      showDeleteCardSuccessful:"",
      permittedContactDetails:{
        fname:'',
        lname:'',
        contactId:'',
        contactEmail:''
      },
      clientDetails:[],
      errorPosition:[],
      alertshow:false,
      showDeleteContactSuccessful:false,
      companyId:"",
      candidateSearchResults: [],
      searchParam: "",
      contactId:"",
      reschedulingCandidate: {},
      autoSuggestionResults: [],
      autoSuggestionParam: null,
      selectedRescheduleJob: {},
      rescheduleResponseMessage: null,
      jobList: [],
      rescheduleStatus: null,
      deletingCandidateId: null,
      isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastId: null,
      disableSentCandidate:false,
      showModal:false,
      currentCompanyName: '',
      viewClicked: false
    };
    this.handleCandidateSelect = this.handleCandidateSelect.bind(this);
    this.handleSendCandidates = this.handleSendCandidates.bind(this);
    this.closeWarningModal = this.closeWarningModal.bind(this);
    this.closeAlertPopUp = this.closeAlertPopUp.bind(this);
    this.handleRemoveContactModal=this.handleRemoveContactModal.bind(this);
    this.handleSuccessfulCardHide = this.handleSuccessfulCardHide.bind(this);
    this.handleSuccessfulHide = this.handleSuccessfulHide.bind(this);
  }

  componentDidMount() {
    if(this.props.jobId) {
      this.props.onGetTalentPoolRecruiter(this.props.jobId,this.props.user);
    }

    if(this.props.recruiterDetails.user_id) {      
      axios.get("/galaxy/job/list?isRecruiterList=1&userId=" + this.props.recruiterDetails.user_id)
        .then((response) => {
        if(response && response.data) {
          const jobs = [...response.data];
          const jobList = jobs.map((job) => {
            return {
                jobId:job.job_id,
                title:job.job_name,
                id:job.job_bh_id
              }
          });
          if(response.data[0]){
            this.setState({ currentCompanyName: response.data[0].client_company});
          }
          this.setState({ jobList : jobList });
        }
      })
      .catch((error) => {
        ConsoleLog(error);
        throw error;
      });
    }
  }

  candidateSearchHandler = (e) => {    
    const searchParam = e.target.value;
    this.setState({searchParam: searchParam});
    const candidateList = [...this.props.pool];
    const candidateSearch = candidateList.filter(candidate => (
      candidate.candidate_source_id.toString().includes(searchParam.toLowerCase())||
      candidate.candidate_fname.toLowerCase().includes(searchParam.toLowerCase()) || 
      candidate.candidate_lname.toLowerCase().includes(searchParam.toLowerCase()) ||
      (candidate.candidate_fname.toLowerCase() + " "  + candidate.candidate_lname.toLowerCase()).includes(searchParam.toLowerCase()) 
      ));
    this.setState({candidateSearchResults: candidateSearch});      
  }

  componentDidUpdate(nextProps) {
    if(this.props.pool && this.props.pool !== nextProps.pool && !this.props.pool[0].message){
      const activeCandidateId = this.props.activeCandidateId;
      const companyId = this.props.pool[0].job_company_id;
      this.setState({ companyId:companyId, 
                      candidateSearchResults:this.props.pool,
                      activeCandidateId: activeCandidateId 
                    });
      if(this.props.pool.find((candidate) => candidate.candidate_edit_status !=="COMPLETED") && !localStorage.getItem('Warning') && !this.state.alertshow) {
        this.setState({alertshow:true});
      }
    }
   
  }
  
  
/**
 * @desc view the selected candidate
 * @param candidateId
 * @return null
 */
  handleCandidateSelect(candidateId,jobId) {
    ConsoleLog('selected cand');
    this.setState({ viewClicked: true });
    this.props.onSelectCandidate(candidateId,jobId);
    this.props.onViewCandidateRecruiter(candidateId, jobId,this.props.user);
    this.refs.pool.scrollIntoView();
  }
/**
 * @desc  confirmation  pop-up to delete the imported candidate 
 * @param candidateId
 * @return null
 */
  deleteConfirm(candidateId) {
    this.setState({ deleteModal:true, deletingCandidateId: candidateId });
  }
   /**
 * @desc Hide popup if the candidate delete get fails
 * @param event
 * @return null
 */
  handleSuccessfulCardHide() {
    this.setState({ showDeleteCardSuccessful:""});
  }
  /**
 * @desc Close the delete confirmation pop-up
 * @param candidateId
 * @return null
 */
  closeDeleteModal(){
    this.setState({deleteModal:false})
  }
  handleRemoveContactModal(contactId){
    ConsoleLog("handleRemoveContactModal",contactId)
    this.setState({deleteContactModal:true,contactId:contactId})
  }

  closeRemoveContactModal(){
    this.setState({deleteContactModal:false})
  }
  /**
 * @desc Hide popup if the permitted contact delete get fails
 * @param event
 * @return null
 */
  handleSuccessfulHide() {
    this.setState({ showDeleteContactSuccessful:""});
  }

  handlePermittedContactChange = (e) => {
    const name = e.target.id;  
    let permittedContactDetails = this.state.permittedContactDetails;
    if(name === "contactEmail") {
      permittedContactDetails[name] = e.target.value.trim();
    }else{
      permittedContactDetails[name] = e.target.value;

    }
    let newErrorPosition = [];
    if(name === "contactEmail") {
      newErrorPosition = this.state.errorPosition.filter((errPosition) => (errPosition !== "contactEmailEmpty" && errPosition !== "contactEmailFormat" && errPosition !== "userRoleMismatch" && errPosition !=="userAlreadyExists"));
    } else {
      newErrorPosition = this.state.errorPosition.filter((errPosition) => errPosition !== name);
    }
    let OverlayShow = this.state.clientDetails?true:false;

    this.setState({permittedContactDetails,errorPosition:newErrorPosition,show:OverlayShow});
  }

  handleAddPermittedContact=(e) => {
    e.preventDefault();
    if(!checkValidity(this.state.permittedContactDetails.contactId,'isNumeric') || this.state.permittedContactDetails.contactId.length > 15 || this.state.permittedContactDetails.fname.trim() === "" 
    || this.state.permittedContactDetails.contactEmail.trim() === "" || this.state.permittedContactDetails.lname.trim() === "" || !checkValidity(this.state.permittedContactDetails.contactEmail,'isEmail') ){
      let errorPosition = [];
      if(this.state.permittedContactDetails.fname.trim() === "") {
        errorPosition = errorPosition.concat('fname');
      }
      if(this.state.permittedContactDetails.lname.trim() === "") {
        errorPosition = errorPosition.concat('lname');
      }
      if(!checkValidity(this.state.permittedContactDetails.contactId,'isNumeric') || this.state.permittedContactDetails.contactId.length > 15) {
        errorPosition = errorPosition.concat('contactId');
      } 
      if(this.state.permittedContactDetails.contactEmail.trim() === "") {
        errorPosition = errorPosition.concat('contactEmailEmpty');
      } else if(!checkValidity(this.state.permittedContactDetails.contactEmail,'isEmail')) {
        errorPosition = errorPosition.concat('contactEmailFormat');
      } 
      
      this.setState({
        errorPosition: errorPosition
      });

    }
    else {   
      this.getPermittedContacttDetails({
        fname:this.state.permittedContactDetails.fname,
        lname:this.state.permittedContactDetails.lname,
        contactId:this.state.permittedContactDetails.contactId,
        email:this.state.permittedContactDetails.contactEmail,
        jobId:this.props.jobId,
        companyId:this.state.companyId
      });
    }
  }

  getPermittedContacttDetails =(PcontactDetails)=>{
    axios.post("/galaxy/job/" + PcontactDetails.jobId + "/send", JSON.stringify(PcontactDetails)).then(response => { 
      if (response.data.message) {
        let errorPosition = [];
        errorPosition = response.data.message == 'Cannot assign job to this user type' ? errorPosition.concat('userRoleMismatch'):errorPosition.concat('userAlreadyExists');
        this.setState({ errorPosition });
      }
      else {
        if(response.data[response.data.length - 1].userCreated){
          response.data.splice(response.data.length - 1, 1);
          axios.post('/galaxy/user/activity',{ email: PcontactDetails.email, activity: "USER_CREATED"})
          .then(resp => {})
          .catch(err => ConsoleLog(err)); 
        }
        let permittedContactDetails = {
          fname:'',
          lname:'',
          contactId:'',
          contactEmail:''
        };
        this.setState({  clientDetails : response.data,permittedContactDetails});    
      }
    })
    .catch((error) => {
      ConsoleLog("error",error)
    });
  }
 /**
 * @desc Delete imported candidates from card
 * @param candidateId
 * @return null
 */
  deleteCandidate(candidateId) { 
    axios.delete("galaxy/job/" + this.props.jobId + "/candidate/" + candidateId)
      .then((response)=> {   
        //ConsoleLog('response',response); 
        let isShowToast = (response.data.message =="Successfully deleted") ? true : false;
        let candidates = [...this.props.pool];
        const candidateIndex = candidates.findIndex(candidate => candidate.candidate_id === candidateId);
        this.props.OnRemoveCandidateRecruiter(candidateIndex);
        const candidateList = candidates.filter(candidate => candidate.candidate_id !== candidateId);
        if(candidateList.length > 0) {
          const candidateId = candidateList[0].candidate_id;
          this.handleCandidateSelect(candidateId,this.props.jobId);
        } 
        if(isShowToast) {
          this.setState({ 
            deleteModal:false ,
            isShowToast:true,
            toastMessage: "Candidate has been removed",
            toastVariant: "success",
            toastId: "tid" + (new Date()).getTime() 
          }); 
        }     
    })
    .catch((error) => {
      ConsoleLog(error);
      throw error;
    });
  }

  /**
   * @desc function to permit only numeric value and length on keypress
   * @param event
   * @return null
   */
  handleKeyPressContactIdChange = (e) => {
    var e = e || window.event; // for trans-browser compatibility
    var charCode = e.charCode || e.which || e.keyCode;                    
    if ((charCode > 31 && (charCode < 47 || charCode > 57)) || this.state.permittedContactDetails.contactId.length >= 15){
      e.preventDefault();
    }
    
    if (e.shiftKey) {
      e.preventDefault();
    } 
  }
  handleSendWarningShow(){
    axios.get("/galaxy/job/list?isPermittedList=1&jobId=" + this.props.jobId)
      .then((response) => {   
      if(response && response.data) {
        this.setState({clientDetails:response.data,sendWarningModal : true});
      }
    })
    .catch((error) => {
      ConsoleLog(error);
      throw error;
    });
  }
  closeWarningModal(e){
    this.setState({sendWarningModal : false,alertshow : false});
  }
  // closeSendSuccessModal(){
  //   this.setState({sendSuccessModal : false});
  // }
  closeAlertPopUp(e){
    this.setState({alertshow : false});
    localStorage.setItem('Warning','true');
  }
/**
 * @desc Send imported candidates to client
 * @param event
 * @return null
 */
  handleSendCandidates(e) {
    this.setState({disableSentCandidate:true})
    const addedCount = this.props.pool.filter(candidate => candidate.published === 0).length;
    const jobDetails = {
      published:1,
      jobId:this.props.jobId,
      addedCount:addedCount,
      userId:this.props.recruiterDetails.user_id
    }
    axios.post("/galaxy/job/" + this.props.jobId + "/send", JSON.stringify(jobDetails))
      .then((response) => {  
        ConsoleLog("send candidate",response);
        if(response.data.message) {

          this.props.onUpdateCandidatePublished();
          this.setState({
            sendWarningModal:false,
            isShowToast:true,
            toastMessage: "Thank you! Your final candidate list has been sent to the client.",
            toastVariant: "success",
            toastId: "tid" + (new Date()).getTime() ,
            disableSentCandidate:false
          });
        }
    })
    .catch((error) => {
      ConsoleLog(error);
      throw error;
    });
  }

  handleRemoveContact = (e) => {
    e.preventDefault();
    // ConsoleLog("handleRemoveContact",this.props.jobId)
    axios.delete("/galaxy/job/" + this.props.jobId + "/permitted-contact?userId=" + this.state.contactId)
    .then((response)=>  {   
      let isShowToast = (response.data.message =="Deleted successfully") ? true : false;  
      this.setState({deleteContactModal:false});
      if(isShowToast) {
        let contactList = [...this.state.clientDetails];
        const filteredList = contactList.filter(contactList => contactList.permitted_contact_id !== this.state.contactId);
        this.setState({
          clientDetails :filteredList,
          isShowToast:true,
          toastMessage: "Permitted contact has been removed",
          toastVariant: "success",
          toastId: "tid" + (new Date()).getTime() 
        })
      }
    })
    .catch((error) => {
      ConsoleLog(error);
      throw error;
    });
  }

  handleClearSearchParam = (event) => {
    this.setState({ searchParam: "", candidateSearchResults:this.props.pool });
  }

  handleRescheduleCandidate = (candidate) => {
    this.setState({ autoSuggestionParam: "", reschedulingCandidate: candidate, autoSuggestionResults: [], selectedRescheduleJob: {} });
  }

  handleCancelReschedule = () => {
    this.setState({ autoSuggestionParam: "", reschedulingCandidate: {}, autoSuggestionResults: [], selectedRescheduleJob: {} });
  }

  handleAutoSuggestion = (event) => {
    const autoSuggestionParam = event.target.value;
    this.setState({ autoSuggestionParam: autoSuggestionParam });
    if(autoSuggestionParam !== "" && autoSuggestionParam !== null) {
      const jobList = [...this.state.jobList.filter((job) => job.id !== this.props.jobId)];
      let autoSuggestionResults = jobList.filter(job => (
        job.jobId.toString() !== this.props.jobId.toString() &&
        (job.id.toString().includes(autoSuggestionParam.toLowerCase())||
        //job.jobId.toString().includes(autoSuggestionParam.toLowerCase())||
        job.title.toLowerCase().includes(autoSuggestionParam.toLowerCase()))
      ));

      this.setState({ autoSuggestionResults: autoSuggestionResults });   
    } else {
      this.setState({ autoSuggestionResults: [] }); 
    }    
  }

  handleRescheduleJobSelect = (selectedRescheduleJob) => {
    this.setState({ selectedRescheduleJob: selectedRescheduleJob });
  }

  handleRescheduleJobSelectClick = () => {
    this.setState({ selectedRescheduleJob: {} });
  }

  handleRescheduleSubmit = () => {
    const reschedulingData = {
      candidateId: this.state.reschedulingCandidate.candidate_id,
      jobId: this.state.selectedRescheduleJob.jobId,
      reschedule: 1
    }

    axios.post("/galaxy/job/" + this.state.selectedRescheduleJob.jobId + "/candidate/" + this.state.reschedulingCandidate.candidate_id, JSON.stringify(reschedulingData))
      .then((response) => {  
        if(response.data.error) {
          this.setState({ rescheduleResponseMessage: response.data.error, rescheduleStatus: 'error' });
  
          setTimeout(() => {
            this.setState({ rescheduleResponseMessage: null, rescheduleStatus: null, reschedulingCandidate: {} });
          }, 2000);
        } else {
          if(response.data.message === "success") {
            this.setState({ rescheduleResponseMessage: "Successfully Rescheduled!", rescheduleStatus: 'success' });
  
            setTimeout(() => {
              let candidates = [...this.props.pool];
              const candidateIndex = candidates.findIndex(candidate => candidate.candidate_id === this.state.reschedulingCandidate.candidate_id);
              this.props.OnRemoveCandidateRecruiter(candidateIndex);
              const candidateList = candidates.filter(candidate => candidate.candidate_id !== this.state.reschedulingCandidate.candidate_id);
              if(candidateList.length > 0 && this.state.reschedulingCandidate.candidate_id === this.props.activeCandidateId) {
                const candidateId = candidateList[0].candidate_id;
                this.handleCandidateSelect(candidateId,this.props.jobId);
              }      
              this.setState({ rescheduleResponseMessage: null, rescheduleStatus: null, reschedulingCandidate: {} });
            }, 3000);
          } else {
            this.setState({ rescheduleResponseMessage: "Candidate Reschedule Failed!", rescheduleStatus: 'error' });
  
            setTimeout(() => {
              this.setState({ rescheduleResponseMessage: null, rescheduleStatus: null, reschedulingCandidate: {} });
            }, 2000);
          }
        }
      })
      .catch((error) => {
        ConsoleLog(error);
        throw error;
      });    
  }
  handleModal = () => {
    window.scrollTo(0,0);
    this.setState({showModal: true});
  }

  handleModalOK = () => {
    this.setState({showModal: false});
    this.props.history.goBack();
  }

  handleViewClick = () => {
    this.setState({viewClicked: false});
  }

  render() {
	  const slickSettings = {
 	    dots: true,
	    infinite: true,
	    centerMode: true,
			centerPadding: '3%',
	    speed: 500,
	    slidesToShow: 1,
	    slidesToScroll: 1
    };
    const publishedCandidates = this.state.candidateSearchResults.filter((candidate) => candidate.published === 1);
    const draftCandidates = this.state.candidateSearchResults.filter((candidate) => candidate.published === 0);

    const candidates = this.props.pool;
    let started = 0;
    let not_started = 0;
    let completed = 0;
    if(candidates && candidates.map(cand => {
        if(cand.candidate_edit_status == 'COMPLETED') {
          completed++;
        } 
        else if(cand.candidate_edit_status == 'STARTED') {
          started++;
        } else {
          not_started++;
        }
    }));
    
  	return (
			<div className="pool pool-recruiter" ref="pool">
			  <MediaQuery query="(min-device-width: 768px)">
		      <Grid>
            <Row className="show-grid">
              <Col xs={12} md={3} className="pool-cards">
                <div className="pool-recruiter__add-candidate-button">
                  <Button 
                    size="large" 
                    width="full" 
                    onClick={this.props.handleAddCandidate}
                  >+ New Candidate</Button>
                </div>
                <div className="pool-recruiter__send-client-button">
                  {(this.props.pool.length>0)
                  ?
                    (<Button 
                        size="large" 
                        onClick={()=>this.handleSendWarningShow()}
                        buttonicon="send-icon"
                        disabled ={this.props.pool.find((candidate) => candidate.candidate_edit_status !=="COMPLETED")? "disabled":""}
                      >
                        Send to Client
                    </Button>) 
                  :
                    (<Button 
                        size="large" 
                        onClick={()=>this.handleSendWarningShow()}
                        buttonicon="send-icon"
                        disabled = "disabled"
                      >
                        Send to Client
                    </Button>)
                  }
                  {this.state.alertshow?
                    <div class="sent-to-client-tooltip permitted-arrow">
                      <h1>You are unable to 'Send to Client' at this time.</h1>
                      <h2>What do I need to do?</h2>
                      <p className="tooltip-p">Please complete all profiles before you 'Send to Client'.</p>
                      <Button className="tooltip-button" onClick={this.closeAlertPopUp}>Got it!</Button> 
                    </div>:""}
                </div>
              {/* {ConsoleLog(' candidates list ' + completed + ' ' + started + ' ' + not_started)} */}
                {this.props.pool && this.props.pool[0] && this.props.pool[0].message && this.props.pool[0].message == "no data" ?
                  <div className="no-candidates">
                    <p>No candidates have been added to this job</p>
                  </div>
                : <div>
                    <hr />
                    <div className="rec-candidates-review-count">

                    <div className="left-div1">
                      <div className="left-div-align">
                        <div className="rec-count-text">{(not_started > 9) ? not_started : '0' + not_started}</div>
                        <div className="rec-count-status">Not Started</div>
                      </div>
                    </div>

                    <div className="middle-div2">
                        <div className="rec-count-text">{(started > 9) ? started : '0' + started}</div>
                        <div className="rec-count-status">Started</div>
                    </div>

                    <div className="right-div3">
                      <div className="right-div-align">
                        <div className="rec-count-text">{(completed > 9) ? completed : '0' + completed}</div>
                        <div className="rec-count-status">Completed</div>
                      </div>
                    </div>

                    </div>
                    <div className="rec-search-box">
                      <SearchBox 
                        value={this.state.searchParam}
                        onChange={this.candidateSearchHandler} 
                        icon={searchIcon}
                        isBorder={true}
                        iconPosition={'left'}
                        iconInside={true}
                        className="candidate-card-search"
                        placeholder="First name, Last name or Bullhorn ID"
                        clearIcon={clearIcon}
                        clearInput={this.handleClearSearchParam}
                      /> 
                    </div>
                    {(this.state.candidateSearchResults.length === 0 && this.state.searchParam!=="") ?
                      <div className="search-results-not-found">No results found</div>
                    :
                    <div>
                      <div>  
                        {(draftCandidates.length > 0 && publishedCandidates.length > 0)?                   
                          <div>
                            <hr/>
                            <div className="recruiter-candidatecard-heading">New Candidates(s)</div>
                          </div>
                        : null}
                        { draftCandidates.map((candidate, index) => (
                        
                        (candidate.candidate_id === this.state.reschedulingCandidate.candidate_id) ?
                          <RescheduleCard
                            handleCancelReschedule={this.handleCancelReschedule}
                            autoSuggestionParam={this.state.autoSuggestionParam}
                            handleAutoSuggestion={this.handleAutoSuggestion}
                            autoSuggestionResults={this.state.autoSuggestionResults}
                            handleClick={this.handleRescheduleJobSelect}
                            reschedulingCandidate={this.state.reschedulingCandidate}
                            selectedRescheduleJob={this.state.selectedRescheduleJob}
                            handleRescheduleJobSelectClick={this.handleRescheduleJobSelectClick}
                            rescheduleResponseMessage={this.state.rescheduleResponseMessage}
                            handleCandidateReschedule={this.handleRescheduleSubmit}
                            rescheduleStatus={this.state.rescheduleStatus}
                          />
                        : 
                        <CandidateCard 
                          isRecruiter={true} 
                          handleCandidateSelect={() => this.handleCandidateSelect(candidate.candidate_id,this.props.jobId)} 
                          key={index} 
                          {...candidate} 
                          id={candidate.candidate_id} 
                          activeCandidateId={this.props.activeCandidateId}
                          removeButton={true}
                          deleteConfirm={() => this.deleteConfirm(candidate.candidate_id)}
                          handleRescheduleCandidate={this.handleRescheduleCandidate}
                          closeModal={this.closeModal}
                          editStatus={candidate.candidate_edit_status}
                        /> 
                      ))} 
                    </div>
                    <div> 
                      {(draftCandidates.length > 0 && publishedCandidates.length > 0)? 
                        <div>
                          <hr/>
                          <div className="recruiter-candidatecard-heading">Previously Submitted Candidates</div> 
                        </div>
                        : null}
                        {publishedCandidates.map((candidate, index) => (
                          (candidate.candidate_id === this.state.reschedulingCandidate.candidate_id) ?
                            <RescheduleCard
                              handleCancelReschedule={this.handleCancelReschedule}
                              autoSuggestionParam={this.state.autoSuggestionParam}
                              handleAutoSuggestion={this.handleAutoSuggestion}
                              autoSuggestionResults={this.state.autoSuggestionResults}
                              handleClick={this.handleRescheduleJobSelect}
                              reschedulingCandidate={this.state.reschedulingCandidate}
                              selectedRescheduleJob={this.state.selectedRescheduleJob}
                              handleRescheduleJobSelectClick={this.handleRescheduleJobSelectClick}
                              rescheduleResponseMessage={this.state.rescheduleResponseMessage}
                              handleCandidateReschedule={this.handleRescheduleSubmit}
                              rescheduleStatus={this.state.rescheduleStatus}
                            />
                          : 
                                              
                            <CandidateCard 
                              isRecruiter={true} 
                              handleCandidateSelect={() => this.handleCandidateSelect(candidate.candidate_id,this.props.jobId)} 
                              key={index} 
                              {...candidate} 
                              id={candidate.candidate_id} 
                              activeCandidateId={this.props.activeCandidateId}
                              removeButton={true}
                              deleteConfirm={() => this.deleteConfirm(candidate.candidate_id)}
                              handleRescheduleCandidate={this.handleRescheduleCandidate}
                              closeModal={this.closeModal}
                              editStatus={candidate.candidate_edit_status}
                            /> 
                            
                          ))}
                    </div>
                  </div>
                  }
                        
                  </div>
                }
              </Col>
              {this.props.pool && this.props.pool[0] && this.props.pool[0].message && this.props.pool[0].message == "no data" ?"":                
              <Col xs={12} md={9} className="profile-panel">
                {(this.props.activeCandidateId !== null) ? 
                  <ProfileEdit 
                    activeCandidateId={this.props.activeCandidateId} 
                    jobId={this.props.jobId}
                    jobTitle={this.props.jobTitle}
                    jobBH={this.props.jobBH}
                    viewClicked={this.state.viewClicked}
                    handleViewClick= {this.handleViewClick}
                    continueClicked={this.props.continueClicked}
                    /> 
                  : null } 
              </Col>}
            </Row>
					  </Grid>
		      </MediaQuery>
		      <MediaQuery query="(max-device-width: 767px)">
		        <Table striped condensed hover>
		          <thead>
		            <tr>
		              <th className="bullhorn-id">Bullhorn ID</th>
		              <th className="name">Name</th>
		              <th className="status">Status</th>
		            </tr>
		          </thead>
		          <tbody>
	            	{this.props.pool.map((candidate, index) => (
                  <CandidateRowMobile 
		                bullhornID={candidate.candidate_source_id} 
                    firstname={candidate.candidate_fname}
                    lastname={candidate.candidate_lname} 
                    activeCandidateId={this.props.activeCandidateId}
                    key={index} {...candidate} 
                    id={candidate.candidate_id} 
                    removeButton={true}
                    deleteConfirm={() => this.deleteConfirm(candidate.candidate_id)}
                    currentEmployer={candidate.current_employer}
                    candidateId={candidate.candidate_id}
                    jobId={this.props.jobId}
                    jobTitle={this.props.jobTitle}
                    jobBH={this.props.jobBH}
                    handleModal={this.handleModal}
		              />
	            	))}  
               <Modal className="rec-no-mobile-modal-mob" show={this.state.showModal} >
                <p>Please use a desktop to edit candidate profiles, this feature is currently disabled on mobile for compliance reasons for this iteration.</p>
                <div className="rec-no-mobile-button-mob">
                  <Button className="rec-no-mobile-ok-mob" onClick={this.handleModalOK}>OK</Button>
                </div>
              </Modal>
		          </tbody>
		        </Table>      
		      </MediaQuery>
          <Modal show={this.state.deleteModal} onHide={()=>this.closeDeleteModal()} className="delete-card-modal">
            <Modal.Body>
            <div className="content-delete">
              <p>You have selected '<span>Remove Candidate</span>'. Are you sure you want to remove this Candidate from the Galaxy?</p>
            </div>    
            <Button className="cancel-delete" onClick={()=>this.closeDeleteModal()}>Cancel</Button> <Button className="confirm-delete"
              onClick={()=>{
                this.deleteCandidate(this.state.deletingCandidateId,this.props.pool.length);
                this.props.passDeleteCandidate(this.state.deletingCandidateId)
              }}>Yes
            </Button>    
            </Modal.Body>
        </Modal>

        <ToastNotification 
        isShowToast={this.state.isShowToast} 
        message={this.state.toastMessage} 
        variant={this.state.toastVariant} 
        onClose={this.handleCloseToastNotification}
        toastId ={this.state.toastId}
        />

        {/* Modal pop up for Add permitted Contact delete Confirmation*/}
        <Modal show={this.state.deleteContactModal} onHide={()=>this.closeRemoveContactModal()}  backdropClassName="delete-contact-modal-backdrop" className="delete-contact-modal">
            <Modal.Body>
            <div className="contact-content-delete">
              <p>You have selected '<span>Remove Permitted Contact Client</span>'. Are you sure you want to remove this Client from the Galaxy?</p>
            </div>    
            <Button className="contact-cancel-delete" onClick={()=>this.closeRemoveContactModal()}>Cancel</Button> <Button className="confirm-contact-delete"
              onClick={(e)=>{this.handleRemoveContact(e)}}>Yes
            </Button>    
            </Modal.Body>
        </Modal>
       {/* Modal pop up for Add permitted Contact delete End */}
       
       {/* Modal pop up for successful delete of Permitted contact data
       <Modal show={this.state.showDeleteContactSuccessful} onHide={this.handleSuccessfulHide} backdropClassName="contact-delete-success-backdrop" className="contact-delete-Successful-modal">
          <Modal.Body>
            <p>Permitted contact has been removed<span className="success-image"></span></p>
          </Modal.Body>
        </Modal>*/}

      {/* SendWarning  Modal starts Add Permitted Contact */}
      <Modal show={this.state.sendWarningModal} className="send-warning-modal">         
        <Modal.Header className="permitted-contact-header-section">
          <Modal.Title>
            <p className="permitted-contact-title">SEND TO CLIENT</p>
            <p className="permitted-contact-desc">Confirm the contacts who will be reviewing the candidates</p>
          </Modal.Title>
        </Modal.Header>
              <div className="permitted-contact-jobtitle">
                  <h2 className="hidden-xs"> {this.props.jobTitle} {this.props.jobBH}</h2>
                  <span>{this.state.currentCompanyName ? this.state.currentCompanyName:null }</span>
              </div>              
              <Modal.Body>
              <Form className="add-permitted-contact-form">
                <Row className="add-permitted-contact-steps show-grid">
                  <Col xs={12} sm={5} className="form-section add-permitted-contact-details">
                    <h2 className="add-permitted-head-2">Add Contacts</h2>
                    {/* <p className="add-permitted-desc-1">Add Permitted Contact to view Candidates for <span className="jobtittle-span">"{this.props.jobTitle}"</span> job.
                    </p> */}
                    <FormGroup
                      controlId="fname"
                    >
                     <ControlLabel>First Name: </ControlLabel>
                     <p className="error-message">{(this.state.errorPosition.includes("fname")) ? "Please provide a First Name to continue" : null}</p>
                       <FormControl
                          type="text"
                          placeholder="Enter First Name"
                          value={this.state.permittedContactDetails.fname}
                          onChange={this.handlePermittedContactChange}
                          className={(this.state.errorPosition.includes("fname"))?"invalid-contact" :""}
                        />
                    </FormGroup>
                    <FormGroup
                      controlId="lname"
                    >
                      <ControlLabel>Last Name: </ControlLabel>
                      <p className="error-message">{(this.state.errorPosition.includes("lname")) ? "Please provide a Last Name to continue" : null}</p>
                      <FormControl
                          type="text"
                          placeholder="Enter Last Name"
                          value={this.state.permittedContactDetails.lname}
                          onChange={this.handlePermittedContactChange}
                          className={(this.state.errorPosition.includes("lname"))?"invalid-contact" :""}
                        />
                    </FormGroup>
                    <FormGroup
                      controlId="contactId"
                    >
                      <ControlLabel>Contact ID: </ControlLabel>
                      <p className="error-message">{(this.state.errorPosition.includes("contactId")) ? "Please provide a valid Contact ID to continue" : null}</p>
                     <FormControl
                          type="text"
                          placeholder="Enter Contact ID"                          
                          value={this.state.permittedContactDetails.contactId}
                          onChange={this.handlePermittedContactChange}
                          onKeyPress={this.handleKeyPressContactIdChange}
                          className={(this.state.errorPosition.includes("contactId"))?"invalid-contact" :""}
                        />
                    </FormGroup>
                    <FormGroup
                      controlId="contactEmail"
                    >
                      <ControlLabel>Email: </ControlLabel>
                       <p className="error-message">{(this.state.errorPosition.includes("contactEmailEmpty")) ? "Please provide a valid Contact Email Address" : 
                        (this.state.errorPosition.includes("contactEmailFormat") ? "Please provide a valid contact email address" : 
                        (this.state.errorPosition.includes("userRoleMismatch") ? "Cannot be assigned to this email" : 
                        (this.state.errorPosition.includes("userAlreadyExists") ? "User already added to the job" :"")))}</p>
                      <FormControl
                          type="text"
                          placeholder="Enter Email"                          
                          value={this.state.permittedContactDetails.contactEmail}
                          onChange={this.handlePermittedContactChange}
                          className={(this.state.errorPosition.includes("contactEmailEmpty")) ? "invalid-contact" : (this.state.errorPosition.includes("contactEmailFormat") ? "invalid-contact" : "")}
                        />
                    </FormGroup>
                    <Button bsStyle="import" className="permitted-contact-add-btn" onClick={(e)=>this.handleAddPermittedContact(e)}>Add</Button>
                  </Col>
                  <Col xs={12} sm={7} className="form-section permitted-contact-list">
                    <div class="scroll-table">
                      <Table striped condensed hover>
                      <h2 className="add-permitted-head-2 contact-list">Contact list</h2>
                        <thead>
                          <tr>
                            <th className="date-added hidden-xs">Date Added</th>
                            <th className="bullhorn-id">Contact ID</th>
                            <th className="name">Name</th>
                            <th className="email hidden-xs">Email</th>
                            {/* <th className="number-of-candidate ">No. of Candidates</th> */}
                            <th className="actions">&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.state.clientDetails?
                          this.state.clientDetails.map((clientDetail, index) => (
                          <PermittedContactRow 
                            key={index}
                            bullhornID={clientDetail.permitted_contact_bh_id} 
                            dateAdded={new Date(clientDetail.permitted_contact_created).toISOString().replace(/T.*/,'').split('-').reverse().join('/')}
                            name={clientDetail.permitted_contact_fname + " " + clientDetail.permitted_contact_lname}                            
                            email={clientDetail.permitted_contact_email} 
                            noOfCandidate={clientDetail.permittednoofcandidates?clientDetail.permittednoofcandidates:clientDetail.noofcandidates}
                            handleRemoveContactModal={()=>this.handleRemoveContactModal(clientDetail.permitted_contact_id)}
                          />                      
                         ))
                          :""}
                        </tbody>
                      </Table> 
                      </div>       
                  </Col>
                </Row>
              </Form>   
                          
              </Modal.Body>
              <Modal.Footer>
                <Button className="cancel-send" onClick={this.closeWarningModal}>Cancel</Button>
                <Button 
                  className={(this.state.clientDetails.length>0 && !this.state.disableSentCandidate)?"confirm-send":"confirm-send-disabled"} 
                  disabled={(this.state.clientDetails.length>0 && !this.state.disableSentCandidate)?false:true} 
                  bsStyle="Primary" 
                  onClick={this.handleSendCandidates}
                >
                Send Candidate List
                </Button>  
              </Modal.Footer>
            </Modal>
          {/* send-success-Modal  starts 
          <Modal show={this.state.sendSuccessModal}  className="send-successfull-modal">
              <Modal.Body>
              <div className="content-send">
                <p className="send-title">THANK YOU!</p>
                <p>Your final candidate list has been sent to the Client.</p>
              </div>    
              <Button className="confirm-send"bsStyle="Primary"onClick={this.closeSendSuccessModal} >Back to Candidate List</Button> 
              </Modal.Body>
          </Modal>
          {/* send-success-Modal Ends */}
        </div>
	  )
  }
}
/**
* @desc connecting to redux store
* @param state
* @return redux state
*/
const mapStateToProps = state => {
  return {
    user:state.cognito.user,
    pool: state.talentPool.pool,
    activeCandidateId: state.talentPool.activeCandidateId,
    recruiterDetails: state.clientProfile.clientDetails,
    completed: state.talentPool.completed && state.talentPool.completed > 0 ? state.talentPool.completed : 0,
    started: state.talentPool.started && state.talentPool.started > 0 ? state.talentPool.started : 0,
    notStarted: state.talentPool.not_started && state.talentPool.not_started > 0 ? state.talentPool.not_started : 0
  };
}

/**
* @desc connecting to redux actions
* @param dispatch
* @return redux actions
*/

const mapDispatchToProps = dispatch => {
  return {
    onGetTalentPoolRecruiter: (jobTitleId,user) => dispatch(actions.getTalentPoolRecruiter(jobTitleId,user)),
    OnClearTalentPoolRecruiter:() =>dispatch(actions.clearTalentPoolRecruiter()),
    onSelectCandidate: (candidateId) => dispatch(actions.viewCandidate(candidateId)),
    onViewCandidateRecruiter: (candidateId, jobTitleId,user) => dispatch(actions.viewCandidateRecruiter(candidateId, jobTitleId,user)),
    OnRemoveCandidateRecruiter:(candidateIndex) =>dispatch(actions.removeCandidateRecruiter(candidateIndex)),
    onUpdateCandidatePublished: () => dispatch(actions.updateCandidatePublished())
  }  
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(PoolRecruiter,axios)));


// WEBPACK FOOTER //
// ./src/container/Recruiter/PoolRecruiter/PoolRecruiter.js